module.exports = __webpack_public_path__ + "static/img/image_empty1_large.180001b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image_empty1_large.png
// module id = 382
// module chunks = 1